import script from "./mainIntro.vue?vue&type=script&setup=true&lang=js"
export * from "./mainIntro.vue?vue&type=script&setup=true&lang=js"

import "./mainIntro.vue?vue&type=style&index=0&id=2ce44854&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ce44854"]])

export default __exports__